<template>
  <div v-if="featureG2SecureEnabled">
    <div class="row">
      <div class="col-8">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>Name</th>
            <th>Status</th>
            <th>Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>HAVEN Lock</td>
            <td>
              <span v-if="featureG2SecureHavenLockConnected"><i class="fa fa-check-circle online" aria-hidden="true"></i> Connected</span>
              <span v-else><i class="fa fa-times-circle offline" aria-hidden="true"></i> Not Connected</span>
            </td>
            <td v-if="featureG2SecureHavenLockConnected">
              <a href="#" class="btn btn-light" @click="HavenLockDisconnect()"><i class="fas fa-ban fa-fw" aria-hidden="true"></i> Disconnect</a>
              <a href="#" class="btn btn-light" @click="HavenLockLoadLocks()"><i class="fa fa-sync fa-fw" aria-hidden="true"></i> Load Locks</a>
            </td>
            <td v-else>
              <a href="#" class="btn btn-light" @click="HavenLockLogin()"><i class="fa fa-sync fa-fw" aria-hidden="true"></i> Connect</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row">
      <div class="col-12">
        <p><strong>G2 Secure is not enabled for your account.</strong></p>
        <h3>G2 Secure: The Ultimate Campus Security and Communication Solution</h3>
        <p>When seconds count, you need a security and communication solution you can count on. That's where G2 Secure comes in.</p>
        <h4>Comprehensive Security and Communication for Your Campus</h4>
        <p>G2 Secure is designed specifically for schools and districts, offering a comprehensive solution for securing your campus and managing emergency situations.</p>
        <p>With G2 Secure, you can:</p>
        <ul>
            <li>Send visual and audible alerts campus-wide</li>
            <li>Send & receive communications across the campus in real-time via our emergency dashboard or iOS mobile app</li>
            <li>Communicate with first responders</li>
            <li>Monitor the status of door locks</li>
            <li>Integrate with our <a href="https://www.galaxynext.us/">G2 LINK Classroom Audio System</a>.</li>
        </ul>
        <p>Don't wait until it's too late to secure your campus and ensure effective communication in emergency situations. Get G2 Secure today and take control of your campus security and communication.</p>
        <p><strong>For more information, please visit our website at <a href="https://www.galaxynext.us/">https://www.galaxynext.us/</a>, or contact us at <a href="mailto:sales@galaxynext.us">sales@galaxynext.us</a> to get started.</strong></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'havenLockOAuthLoginUrl',
      'featureG2SecureHavenLockConnected',
      'featureG2SecureEnabled'
    ])
  },
  created () {
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE')
  },
  methods: {
    HavenLockLogin () {
      this.$store.dispatch('getHavenLockOAuthUrl').then(() => {
        window.location.href = this.havenLockOAuthLoginUrl
      })
    },
    HavenLockDisconnect () {
      if (prompt("If you disconnect, you will not be able to control or access any HAVEN locks.\n\nTo confirm that you want to disconnect from the HAVEN system,\n\nPlease type 'DISCONNECT' in the box below.\n\n").toLowerCase() === 'disconnect') {
        this.$store.dispatch('disconnectHavenLock')
      }
    },
    HavenLockLoadLocks () {
      this.$store.dispatch('loadLocksHavenLock')
    }
  }
}
</script>

<style scoped>

</style>
